import React from 'react';
import Button from '../../components/buttons/Button';
import Modal from '../../components/modal.v2/Modal';

export default class ConfirmacaoCartao extends React.Component{
  constructor(props){
    super(props);

    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleSubmit(e){
    e.preventDefault();
    this.props.history.push('/area-restrita/bem-vindo/');
    Modal.destroy();
  }

  render(){
    return(
      <div>
        <div className='box-title'>
          <div className='title-parabens'>Parabéns</div>
          <div className='subtitle-parabens'>sua compra foi aprovada!</div>
        </div>
        <div className=''>
          <p><strong>Agora você faz parte da equipe Foco90.</strong></p><br />
          <p>
          {/*Este é um PRODUTO DIGITAL, você receberá os dados para acessá-lo via app ou email!<br /><br />*/}
Em caso de dúvidas ou necessidade de suporte relacionado ao produto / serviço, fique à vontade para entrar em contato com nosso suporte através do email <strong>contato@foco90.com.br</strong></p>
          <br />
          <br />
          <br />
            <Button
              text="Acessar meu treino"
              type='button'
              classes="button-login simple-button"
              onClick={this.handleSubmit}
            />
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/classes/pagamento/ConfirmacaoCartao.js